import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CanActivate, CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SignatureFailledDialogComponent } from 'src/components/signature-failled-dialog/signature-failled-dialog.component';
import { ErrorReportService } from 'src/services/error-report.service';
import { HttpService } from 'src/services/http.service';

@Injectable({
  providedIn: 'root'
})
export class SignatureStatusGuard implements CanActivate, CanActivateChild {

  constructor(
    private http: HttpService,
    private errorReport: ErrorReportService,
    private dialog: MatDialog
  ) {

  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.getSignatureStatus();
  }
  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.getSignatureStatus();
  }

  private getSignatureStatus() {

    const user = JSON.parse(localStorage.getItem('token'));
    const params = {
      id: user.id
    }

    return this.http.list('profile:signature_status', params)
      .pipe(
        map(
          (result: any) => {
            
            const { data } = result;
            
            if(data.signature_status === 'CANCELED') {

              const user = JSON.parse(localStorage.getItem('token'));              
              user.signature_status = 'CANCELED';
              user.signature_status_text = data.signature_status_text;
              localStorage.setItem('token', JSON.stringify(user));

              /*const options = {
                width: '600px',
                data: {
                  signatureStatusText: data.signature_status_text
                }
              };
              this.dialog.open(SignatureFailledDialogComponent, options)
                .afterClosed()
                .subscribe(
                  () => window.location.reload()
                )*/

              //return false;

            }

            return true;

          }
        )
      )
    
    

  }
  
}
